import Badge from '@/modules/common/components/Badge.tsx';

interface OverdueTaskBadgeProps {
  count?: number;
}

const OverdueTaskBadge = ({ count }: OverdueTaskBadgeProps) => {
  return (
    <Badge type="critical" className="!text-[#DC2626]">
      Overdue {!!count && `x${count}`}
    </Badge>
  );
};

export default OverdueTaskBadge;
